angular.module('cfn').controller('bookingExportWizardController', [
  '$rootScope',
  '$scope',
  'dialog',
  '$injector',
  '$filter',
  '$timeout',
  '$http',
  '$q',
  'tracker',
  'farmnet.FeatureToggleService',
  function(
    $rootScope,
    $scope,
    dialog,
    $injector,
    $filter,
    $timeout,
    $http,
    $q,
    tracker,
    toggleService
  ) {
    let url_booking_attachment = '/365FarmNet/mod/booking-service/booking/attachment/rest/v1.0/list/';

    // Steps: export > summary
    var controller = this;

    tracker.trackEvent('ISO_XML_EXPORT', 'OPEN');

    controller.helpDisplayed = false;
    controller.step = 0;
    controller.steps = [];
    controller.steps.push({
      id: 'preview',
      i18n: $filter('i18n')('fe.core.wizards.isoExport.export'),
      enabled: false
    });
    controller.steps.push({
      id: 'summary',
      i18n: $filter('i18n')('fe.core.wizards.isoExport.summary'),
      help: $filter('i18n')('fe.core.wizards.isoExport.summary.description'),
      enabled: false
    });

    // parameters
    var selectedTasks = $('#dataGrid')
      .isolateScope()
      .controller.getSelectedRows();
    var planningTasks = _.filter(selectedTasks, function(x) {
      return x.data.state === 'INPLANNING';
    });
    var idArray = _.map(planningTasks, function(x) {
      return x.data.id;
    });
    var idString = _.reduce(
      idArray,
      function(x, i) {
        return (x += '##' + i);
      },
      ''
    ).substr(2);
    controller.parameters = {
      ids: idString,
      includeGeometries: true,
      includeABLineGeometries: false,
      includePrescriptionMaps: false,
      // default is 'NONE' / v2.1
      terminals: 'NONE',
      minimalExport: true
    };
    controller.includePrescriptionMapsPossible = false;

    _.each(idArray, id => {
      if (controller.includePrescriptionMapsPossible) {
        return;
      }
      $http({
        method: 'GET',
        url: url_booking_attachment + id
      }).then(response => {
        var data = response.data;
        data.forEach(obj => {
          if (
            !controller.includePrescriptionMapsPossible &&
            obj.type === 'PRESCRIPTION_MAP'
          ) {
            controller.includePrescriptionMapsPossible = true;
            controller.parameters.includePrescriptionMaps = true;
          }
        });
      });
    });

    // retrieve available terminals from backend
    controller.options = { terminals: [] };
    $http({
      method: 'GET',
      url: '/365FarmNet/rest/booking/isoxml/supportedterminals'
    }).then(
      function(response) {
        var data = response.data;
        _.each(data.terminals, function(element, index, list) {
          controller.options.terminals.push({
            key: element.id,
            value: element.label
          });
        });
      },
      function() {
        controller.options = {
          terminals: [{ key: 'NONE', value: 'ISO-XML (v2.1)' }]
        };
      }
    );

    controller.currentStep = function() {
      return controller.steps[controller.step];
    };

    controller.validateExport = function() {
      // validation / explanatory text in first wizard step
      var tplPlanningTasksSingular = _.template(
        $filter('i18n')(
          'fe.core.wizards.isoExport.valid.planningTasksSingular',
          '<%= num %> Planauftrag wird exportiert.'
        )
      );
      var tplPlanningTasksPlural = _.template(
        $filter('i18n')(
          'fe.core.wizards.isoExport.valid.planningTasksPlural',
          '<%= num %> Planaufträge werden exportiert.'
        )
      );
      var tplIgnoredTasksSingular = _.template(
        $filter('i18n')(
          'fe.core.wizards.isoExport.valid.ignoredTasksSingular',
          'Nur Planaufträge können exportiert werden. <%= num %> markierte sonstige Buchung wird ignoriert.'
        )
      );
      var tplIgnoredTasksPlural = _.template(
        $filter('i18n')(
          'fe.core.wizards.isoExport.valid.ignoredTasksPlural',
          'Nur Planaufträge können exportiert werden. <%= num %> markierte sonstige Buchungen werden ignoriert.'
        )
      );
      var txtNoTasks = $filter('i18n')(
        'fe.core.wizards.isoExport.valid.noTasks',
        'Keine Aufträge sind markiert. Alle Stammdaten werden exportiert.'
      );
      controller.validationMessages = [];
      if (selectedTasks.length !== planningTasks.length) {
        var num = selectedTasks.length - planningTasks.length;
        var tpl = num === 1 ? tplIgnoredTasksSingular : tplIgnoredTasksPlural;
        controller.validationMessages.push({
          type: 'error',
          msg: tpl({ num: num })
        });
      }
      if (planningTasks.length === 0) {
        controller.validationMessages.push({
          type: 'info',
          msg: txtNoTasks
        });
      } else {
        var num = planningTasks.length;
        var tpl = num === 1 ? tplPlanningTasksSingular : tplPlanningTasksPlural;
        controller.validationMessages.push({
          type: 'info',
          msg: tpl({ num: num })
        });
      }
    }; // validateExport

    controller.invalidLoading = false;
    controller.showInvalidItems = false;
    controller.machines = [];
    controller.showMachines = 0;

    controller.lookupFendt = function() {
      if (controller.showMachines == 0) {
        $http({
          method: 'GET',
          url: '/365FarmNet/rest/core/machine/fendt',
          params: { serialnumber: true, isIsoXml: true }
        }).then(function(response) {
          var data = response.data;
          _.each(data, function(machine) {
            controller.machines.push({
              serienNr: machine.serialnumber,
              name: machine.name
            });
          });
          if (controller.machines.length > 0) {
            controller.showMachines = 1;
            controller.info = $filter('i18n')(
              'fe.core.wizards.isoExport.info',
              'bitte eine Maschine auswählen.'
            );
            return;
          }
        });
      }

      controller.showMachines = 2;
      controller.error = $filter('i18n')(
        'fe.core.wizards.isoExport.error',
        'keine passende Maschine vorhanden.'
      );
    };

    controller.validateMachines = function() {
      controller.invalidItems = [];
      var lookupMachine = function(id) {
        return $http
          .get('/365FarmNet/rest/core/machine/' + id)
          .then(function(response) {
            var data = response.data;
            // validate serialnumber
            if (!data.machine.serialnumber) {
              controller.invalidItems.push({
                id: data.machine.id,
                name: data.machine.name
              });
              controller.showInvalidItems = true;
            } // validate serialnumber
          });
      };

      controller.invalidLoading = true;
      var lookupMachinePromises = {};
      _.each(planningTasks, function(plannedTask) {
        if (plannedTask.data && plannedTask.data.resources) {
          _.each(plannedTask.data.resources, function(resource) {
            if (resource.id && resource.type && resource.type === 'Machine') {
              if (!lookupMachinePromises[resource.id]) {
                lookupMachinePromises[resource.id] = lookupMachine(resource.id);
              }
            }
          });
        }
      });

      $q.all(lookupMachinePromises).then(function() {
        controller.invalidLoading = false;
      });
    }; // validateMachines

    controller.invalidEdit = function(id) {
      // ignore
    };

    controller.cssStepClassStr = function(step) {
      var result = 'step';
      if (step.enabled) {
        result += ' step-ready';
      } else {
        result += ' step-disabled';
      }
      return result;
    };

    controller.cssStepArrowClassStr = function(step) {
      var result = 'step-arrow';
      if (step.enabled) result += ' step-arrow-ready';
      return result;
    };

    controller.exportRunning = false;
    function exportStart() {
      controller.exportRunning = true;
      controller.exportResult = null;
    }

    function exportStop() {
      controller.exportRunning = false;
      controller.step += 1;
      controller.steps[controller.step].enabled = true;
    }

    function exportRun() {
      exportStart();

      $http({
        method: 'POST',
        url: '/365FarmNet/rest/booking/isoxml/export',
        data: $.param(controller.parameters),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(
          function(response) {
            var data = response.data;
            var status = response.status;
            switch (status) {
              case 200:
                controller.exportResult = data;
                controller.steps[controller.step + 1].help = $filter('i18n')(
                  'fe.core.wizards.isoExport.summary.descriptionForZip'
                );
                controller.downloadUrl =
                  '/365FarmNet/rest/booking/isoxml/download?downloadId=' +
                  data.downloadId;
                break;

              case 204:
                controller.exportResult = {
                  failureMessages: [
                    {
                      type: 'ERROR',
                      value: $filter('i18n')(
                        'fe.core.wizards.isoExport.nocontent',
                        'Es konnte kein ISO-XML generiert werden, bitte den Vorgang nochmals wiederholen. Sollte die Operation mehrfach fehlschlagen, wenden Sie sich bitte an den Support.'
                      )
                    }
                  ]
                };
                break;

              default:
                controller.exportResult = {
                  failureMessages: [
                    {
                      type: 'ERROR',
                      value: $filter('i18n')(
                        'fe.core.wizards.isoExport.error',
                        'Ein Fehler ist aufgetreten.'
                      )
                    }
                  ]
                };
            }
          },
          function() {
            controller.exportResult = {
              failureMessages: [
                {
                  type: 'ERROR',
                  value: $filter('i18n')(
                    'fe.core.wizards.isoExport.error',
                    'Ein Fehler ist aufgetreten.'
                  )
                }
              ]
            };
          }
        )
        .finally(exportStop);
    }

    function doDownload() {
      var a = document.createElement('a');
      a.href = controller.downloadUrl;
      a.target = '_blank';
      $('#isoXmlExportDownloadLinks').append(a);
      a.click();
      controller.close('ok');
      // tracking
      var prescriptionMap = controller.parameters.includePrescriptionMaps
        ? 'WITH_PRESCRIPTION_MAP'
        : 'WITHOUT_PRESCRIPTION_MAP';
      var exportedFields =
        controller.exportResult && controller.exportResult.exportedFields;
      tracker.trackEvent(
        'ISO_XML_EXPORT',
        'DOWNLOAD_' + prescriptionMap,
        'EXPORTED_FIELDS_COUNT',
        exportedFields
      );
    }

    controller.nextActionFendt = function() {
      controller.uebergabe = false;
      if (controller.step === 0) {
        $.each(controller.machines, function(k, item) {
          if (item.serienNr == controller.serienNr) {
            controller.selectedMachine = $filter('i18n')(
              'fe.core.wizards.isoExport.selectedMachine',
              'ausgewählte Maschine: {0}, Serien-Nr {1}',
              item.name,
              item.serienNr
            );
          }
        });
        exportRun();
      } else if (controller.step === 1) {
        controller.exportRunning = true;
        controller.uebergabe = true;
        $timeout(function() {
          controller.exportRunning = false;
          controller.info = $filter('i18n')(
            'fe.core.wizards.isoExport.exportSuccess',
            'Senden erfolgreich !'
          );
        }, 1000);
      }
    };

    controller.nextAction = function() {
      if (controller.step === 0) {
        exportRun();
      } else if (controller.step === 1) {
        doDownload();
      }
    };

    controller.previousAction = function() {
      controller.uebergabe = false;
      if (controller.step === 1) {
        controller.steps[controller.step].enabled = false;
        controller.step -= 1;
      }
    };

    controller.nextDisabledFendt = function() {
      if (controller.step === 0) {
        if (controller.serienNr) {
          controller.info = '';
          return false;
        } else {
          controller.info = $filter('i18n')(
            'fe.core.wizards.isoExport.info',
            'bitte eine Maschine auswählen.'
          );
          return true;
        }
      } else if (controller.step === 1) {
        if (controller.uebergabe == true) {
          return controller.uebergabe;
        }
        return (
          controller.exportResult &&
          controller.exportResult.failureMessages &&
          controller.exportResult.failureMessages.length > 0
        );
      }
      return false;
    };

    controller.nextDisabled = function() {
      if (controller.step === 0) {
        return controller.exportRunning;
      } else if (controller.step === 1) {
        return (
          controller.exportResult &&
          controller.hasErrorMsgs(controller.exportResult.failureMessages)
        );
      }
      return false;
    };

    controller.hasErrorMsgs = function(messages) {
      if (messages && messages.length > 0) {
        return _.contains(messages, function(entry) {
          return entry.type === 'ERROR';
        });
      }
      return false;
    };

    controller.previousDisabled = function() {
      if (controller.step === 0) {
        return true;
      }
      return false;
    };

    controller.nextLabelFendt = function() {
      if (controller.step === 0) {
        return $filter('i18n')('fe.core.wizards.isoExport.weiter', 'Weiter');
      } else if (controller.step === 1) {
        return $filter('i18n')('fe.common.senden', 'Senden');
      }
      return $filter('i18n')('fe.common.next', 'Weiter');
    };

    controller.nextLabel = function() {
      if (controller.step === 0) {
        return $filter('i18n')(
          'fe.core.wizards.isoExport.export',
          'Exportieren'
        );
      } else if (controller.step === 1) {
        return $filter('i18n')('fe.common.download', 'Herunterladen');
      }
      return $filter('i18n')('fe.common.next', 'Weiter');
    };

    controller.previousLabel = function() {
      return $filter('i18n')('fe.common.prev', 'Zurück');
    };

    controller.cancel = function() {
      if (controller.exportRunning) exportStop();
      controller.close('cancel');
    };

    controller.close = function(action) {
      console.debug('ISOXML Export exited:', action);
      var response = {
        action: action
      };

      if (action === 'ok') {
        response.exportedIds = _.chain(selectedTasks)
          .pluck('data')
          .pluck('id')
          .value();
      }

      dialog.close(response);
    };

    controller.toggledIncludeGeometries = function() {
      if (!controller.parameters.includeGeometries) {
        controller.parameters.includeABLineGeometries = false;
      }
    };

    controller.toggledIncludeABLineGeometries = function() {
      if (controller.parameters.includeABLineGeometries) {
        controller.parameters.includeGeometries = true;
      }
    };

    controller.toggledIncludePrescriptionMaps = function() {
      if (controller.parameters.includePrescriptionMaps) {
        controller.parameters.includeGeometries = true;
      }
    };

    controller.validateExport();

    controller.step = 0;
    controller.steps[controller.step].enabled = true;

    return app.farmnetControllers.finishController(
      'isoExportWizardController',
      $scope,
      this,
      $injector
    );
  }
]);
